import { useQuery } from '@tanstack/react-query';
import { allocationQueries } from '../queries';
import type { SummaryFilters } from '../types/Summary';

export function useSummary(filters: SummaryFilters) {
  return useQuery(allocationQueries.summary(filters));
}
